import React, { Component } from 'react'
import { connect } from 'react-redux'
import { UserRoleActions, SnackbarActions } from 'actionsets'
import { Pagination, ErrorBanner } from 'components'
import Dependent from 'containers/shared/Dependent'
import AddIcon from '@material-ui/icons/Add'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import MuiList from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import RoleIcon from '@material-ui/icons/AccountBox'
import { compose, errorStringsFromError } from 'utils'
import { withRouter } from 'react-router-dom'
import { FABAbsolute } from 'components'

export class List extends Component{

  constructor(props){
    super(props)
    UserRoleActions.bindActions(this)
    SnackbarActions.bindActions(this, 'snackbar')
  }

  state = {
    page: 1
  }

  dependsOn(){
    return this.loadUserRoles()
  }

  loadUserRoles = () => {
    return this.actions.index({
      params: { organisationId: this.organisationId },
      page: this.state.page,
      pageSize: 6,
      fields: {organisation_roles: 'name'}
    })
  }

  dependenciesMet(){
    return this.props.requests.length === 0
  }

  showUserRole = id => () => {
    this.props.history.push(`/user_roles/${id}`)
  }

  editUserRole = id => event => {
    this.props.history.push(`/user_roles/${id}/edit`)
    event.stopPropagation()
  }

  deleteUserRole = id => event => {
    this.actions.destroy({id})
                .then(this.loadUserRoles)
                .catch(error => this.actions.snackbar.show(errorStringsFromError(error).join(', ')))
    event.stopPropagation()
  }

  handlePageSelected = page =>
    this.setState({page}, this.loadUserRoles)

  get organisationId(){
    return this.props.organisationId || this.props.match.params.id
  }

  get userRoles(){
    return this.props.userRoles
  }

  get organisationPermissions(){
    return this.props.organisationPermissions || {}
  }

  get errors(){
    let errors = []
    if(this.props.errors.index){
      errors = errors.concat(this.props.errors.index)
    }
    if(this.props.errors.destroy){
      errors = errors.concat(this.props.errors.destroy)
    }
    return errors
  }

  renderUserRoleListItem = ({id, name}) =>
    <ListItem button onClick={this.showUserRole(id)} key={id}>
      <ListItemIcon>
        <RoleIcon />
      </ListItemIcon>
      <ListItemText primary={name}/>
    </ListItem>

  renderErrorMessages = () =>
    <ErrorBanner>
      {errorStringsFromError(this.errors)}
    </ErrorBanner>

  render = () =>
    <Card>
      <CardContent>
        {this.renderErrorMessages()}
        <MuiList dense>
          {this.userRoles.map(this.renderUserRoleListItem)}
        </MuiList>
        <Pagination totalPages={this.props.totalPages} page={this.props.page} onPageSelected={this.handlePageSelected} style={{}} linkStyle={{}}/>
        {
          this.organisationPermissions.writeUsers &&
          <FABAbsolute color='primary' onClick={() => this.props.history.push(`/organisations/${this.organisationId}/user_roles/new`)}>
            <AddIcon/>
          </FABAbsolute>
        }
      </CardContent>
    </Card>
}

export default compose(
  Dependent({loader: false}),
  withRouter,
  connect(({userRoles}) => userRoles)
)(List)